import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwLoader } from '@spaces-ui/meadow/components/loader';

import { Sample } from '../../components';

@Component({
  selector: 'app-loader',
  templateUrl: './loaders.html',
  styleUrls: ['./loaders.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Sample, MdwLoader, MdwButton],
})
export class Loaders {}
